angular.module('impactx.imageUpload').controller('ImageUploadCtrl', [
    '$scope',
    'ImageEditor',
    ImageUpload
]);

function ImageUpload($scope, ImageEditor) {
    $scope.defaultImageUrl = "img/profile_image_default.png";

    $scope.showImageEditor = function(event, currentImage, newImage) {
        ImageEditor.open(event, currentImage, newImage, 'circle').then(function (croppedImage) {
            if(!croppedImage) {
                return
            } if(!croppedImage.image) {
                $scope.image = undefined;
            } else {
                $scope.image = croppedImage.image;
            }
        })
    }
}